import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { OwlOptions } from "ngx-owl-carousel-o";

@Component({
  selector: "app-our-packages-details",
  templateUrl: "./our-packages-details.component.html",
  styleUrls: ["./our-packages-details.component.scss"],
})
export class OurPackagesDetailsComponent implements OnInit {
  projectName: string = "";
  projects: any = {
    eshop: {
      link: "https://eshop.codesroots.com",
      about:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      websitePhoto:
        "../../../assets/images/our packages/details/eshop/Laptop@2x(1).png",
      mobilePhoto:
        "../../../assets/images/our packages/details/emart/new_img.png",
      specifications:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      appStoreLink: "",
      googlePlayLink: "",
      presents:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      sliderImages: [
        "../../../assets/images/our packages/details/eshop/Laptop@2x.png",
        "../../../assets/images/our packages/details/eshop/Mask Group 10@2x.png",
        "../../../assets/images/our packages/details/eshop/Mask Group 11@2x.png",
      ],
    },
    emart: {
      link: "https://emart.codesroots.com",
      about:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      websitePhoto:
        "../../../assets/images/our packages/details/emart/Laptop@2x.png",
      mobilePhoto:
        "../../../assets/images/our packages/details/emart/new_img.png",
      specifications:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      appStoreLink: "",
      googlePlayLink: "",
      presents:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      sliderImages: [
        "../../../assets/images/our packages/details/emart/Laptop@2x(1).png",
        "../../../assets/images/our packages/details/emart/Mask Group 10@2x.png",
        "../../../assets/images/our packages/details/emart/Mask Group 11@2x.png",
      ],
    },
    "el-ezaby": {
      link: "https://el-ezaby.codesroots.com",
      about:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      websitePhoto:
        "../../../assets/images/our packages/details/el-ezaby/Laptop-1@2x.png",
      mobilePhoto:
        "../../../assets/images/our packages/details/el-ezaby/new_img.png",
      specifications:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      appStoreLink: "",
      googlePlayLink: "",
      presents:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      sliderImages: [
        "../../../assets/images/our packages/details/el-ezaby/Laptop@2x.png",
        "../../../assets/images/our packages/details/el-ezaby/Mask Group 10@2x.png",
        "../../../assets/images/our packages/details/el-ezaby/Mask Group 11@2x.png",
      ],
    },
    ximivogueegypt: {
      link: "https://ximivogueegypt.codesroots.com",
      about:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      websitePhoto:
        "../../../assets/images/our packages/details/ximivogueegypt/Laptop@2x.png",
      mobilePhoto:
        "../../../assets/images/our packages/details/ximivogueegypt/new_img.png",
      specifications:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      appStoreLink: "",
      googlePlayLink: "",
      presents:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      sliderImages: [
        "../../../assets/images/our packages/details/ximivogueegypt/Laptop@2x.png",
        "../../../assets/images/our packages/details/ximivogueegypt/Mask Group 10@2x.png",
        "../../../assets/images/our packages/details/ximivogueegypt/Mask Group 11@2x.png",
      ],
    },
    gad: {
      link: "https://gad.codesroots.com",
      about:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      websitePhoto:
        "../../../assets/images/our packages/details/gad/Laptop-1@2x.png",
      mobilePhoto:
        "../../../assets/images/our packages/details/gad/new_img.png",
      specifications:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      appStoreLink: "",
      googlePlayLink: "",
      presents:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      sliderImages: [
        "../../../assets/images/our packages/details/gad/Laptop@2x.png",
        "../../../assets/images/our packages/details/gad/Mask Group 10@2x.png",
        "../../../assets/images/our packages/details/gad/Mask Group 11@2x.png",
      ],
    },
    abohassan: {
      link: "https://abohassan.codesroots.com",
      about:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      websitePhoto:
        "../../../assets/images/our packages/details/abohassan/Laptop-1@2x.png",
      mobilePhoto:
        "../../../assets/images/our packages/details/abohassan/new_img.png",
      specifications:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      appStoreLink: "",
      googlePlayLink: "",
      presents:
        "This text is an example of text that can be replaced in the same space. This text was generated from the Arabic text generator, where you can generate such text or many other texts in addition to increasing the number of characters generated by the application.",
      sliderImages: [
        "../../../assets/images/our packages/details/abohassan/Laptop@2x.png",
        "../../../assets/images/our packages/details/abohassan/Mask Group 10@2x.png",
        "../../../assets/images/our packages/details/abohassan/Mask Group 11@2x.png",
      ],
    },
  };
  project: any;

  customOptions: OwlOptions = {
    loop: true,
    nav: false,
    dots: true,
    autoplay: true,
    rtl: this.cookie_s.get("lang") == "ar",
    autoplayHoverPause: true,
    items: 3,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
    },
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private cookie_s: CookieService
  ) {}

  ngOnInit(): void {
    this.projectName = this.activatedRoute.snapshot.params["name"];
    this.project = this.projects[this.projectName];
  }
}
